module.exports = __webpack_public_path__ + "img/anomaly-ru.1185e1a1.jpg";